<template>
  <div class="app-container" style="padding-bottom:50px;background: #f4f5f7;">
    <BjSteps active="4" :title="$t('workOrderList.Submit')" :defaultOptions="[$t('workOrderList.step1'),$t('workOrderList.step2'),$t('workOrderList.step3'),$t('workOrderList.step4')]">
      <template slot="right">
        <!-- 返回 -->
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <!-- 日志 -->
        <el-button v-if="$route.query.type != 'add'" type="primary" @click="showLog">{{ $t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
        <!-- 保存 =====>>>>>   新增 的时候用   -->
        <el-button v-if="['add','edit'].includes($route.query.type)" type="primary" @click="handleConfirm">{{ $t('saveText') }}</el-button>
        <!-- 提交 =====>>>>>   新增 的时候用   -->
        <el-button v-if="$route.query.type == 'add'" type="primary" @click="handleSubmit">{{ $t('submitText') }}</el-button>
        <!-- 提交 =====>>>>>   审核 的时候用   -->
        <el-button v-if="$route.query.type == 'audit'" type="primary" @click="handleSubmitChoose">{{ $t('submitText') }}</el-button>
        <!-- 提交 =====>>>>>   完单 的时候用   -->
        <el-button v-if="$route.query.type == 'completed'" type="primary" @click="handleFinish">{{ $t('submitText') }}</el-button>
        <!-- 提交 =====>>>>>  确认收费 的时候用 -->
        <el-button v-if="$route.query.type == 'hoursDone'" type="primary" @click="ConfirmTime">{{ $t('submitText') }}</el-button>
      </template>
    </BjSteps>
    
    <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="160px">
      <div class="flex flex-spacebetween profit-top">
        <BjDivider>{{ $t('workOrderList.TicketInformation') }}</BjDivider>
        <div class="profit-topLeft">
          <el-row :gutter="20" style="margin-top: 10px;">
            <!-- 工单标题 -->
            <!-- <el-col :span="colSpan/2">
              <el-form-item :label="$t('workOrderList.WOTitle')" prop="title">
                <BjInput :disabled="['view','audit','completed','hoursDone'].includes($route.query.type)" v-model="form.title" :maxlength="MAX_LENGTH.DEFAULT" show-word-limit />
              </el-form-item>
            </el-col> -->
            <!-- 客户名称 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="form.cusId" :option-list="customerList" :disabled="['view','audit','completed','hoursDone'].includes($route.query.type) || $store.getters.cusId" @change="changeCustomer" :placeholder="$t('customerNameText')" />
              </el-form-item>
            </el-col>
            <!-- 客服 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('workOrderList.Customer')" prop="customer">
                <BjInput disabled v-model="form.customer"/>
              </el-form-item>
            </el-col>
            <!-- 工单编号 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('workOrderList.Number')" prop="workNo">
                <BjInput disabled v-model="form.workNo"/>
              </el-form-item>
            </el-col>
            <!-- 部门 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('WorkorderType.table.InquiryType')" prop="consultType">
                <BjSelectLov :disabled="['view','audit','completed','hoursDone'].includes($route.query.type)" v-model="form.consultType" :option-list="consultNameTopList" @change="getNextList"/>
              </el-form-item>
            </el-col>
            <!-- 服务 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('workOrderList.service')" prop="workOrderTypeId">
                <BjSelectLov :disabled="['view','audit','completed','hoursDone'].includes($route.query.type) || !form.consultType" v-model="form.workOrderTypeId" :option-list="workOrderTypeIdList" />
              </el-form-item>
            </el-col>
            <!-- 相关类型 -->
            <el-col :span="colSpan/3*2">
              <el-form-item :label="$t('workOrderList.typeTitle')" prop="relevance">
                <BjSelectLov :disabled="!['add','edit'].includes($route.query.type)" v-model="form.relevance" :option-list="skuOrderPoList" @change="form.workOrderSpoVOList=[]" :clearable="false"/>
              </el-form-item>
            </el-col>
            <!-- 处理部门 -->
            <!-- <el-col :span="colSpan/2">
              <el-form-item :label="$t('workOrderList.Operations')" prop="operationDepartment">
                <BjInput disabled v-model="form.operationDepartment"/>
              </el-form-item>
            </el-col> -->
            <el-col :span="colSpan*2">
              <div>
                <div style="float: left;line-height: 2;margin-top: 10px;font-size: 14px;font-weight: 700;color: #606266;" class="bj-form-title">{{$t('workOrderList.typeTitle')}}:</div>
                <div style="float: right;margin-bottom: 10px;">
                  <el-button :disabled="SELECTED_BJ_EBC_ID.length == 0 || !['add','edit'].includes($route.query.type)" type="danger" @click="onBatchDelete">{{ $t('goodsSku.package.delete') }}</el-button>
                  <el-button :disabled="!['add','edit'].includes($route.query.type) || ![1,2,3].includes(form.relevance)" type="primary" @click="openSelectForm">{{ $t('addText') }}</el-button>
                </div>
              </div>
              <el-table v-if="[1,2,3].includes(form.relevance)" :data="form.workOrderSpoVOList" stripe border :header-cell-style="$rowStyle.DEFAULT" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" />

                <!-- SKU -->
                <el-table-column v-if="form.relevance==1" prop="skuName" :label="$t('ExternalOrders.newAdd.ProductName')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==1" prop="standardSkuCode" :label="$t('SalesOrderToBeApproved.SKU')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==1" prop="barCode" :label="$t('workOrderList.bar')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==1" prop="quantity" :label="$t('DetailsOfThirdPartySalesOrder.Quantity')" align="center">
                  <template slot-scope="scope" v-if="form.relevance==1">
                    <BjInputNumber :disabled="!['add','edit'].includes($route.query.type)" v-model="scope.row.quantity" />
                  </template>
                </el-table-column>

                <!-- PO -->
                <el-table-column v-if="form.relevance==2" prop="code" :label="$t('billingPage.code')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==2" prop="shippingMethod" :label="$t('BusinessPurchaseOrder2.means')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==2" prop="containerId" :label="$t('BusinessPurchaseOrder2.form.containerId')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==2" prop="status" :label="$t('table.statusText')" show-overflow-tooltip align="center" />

                <!-- Order -->
                <el-table-column v-if="form.relevance==3" prop="webReference" :label="$t('InternalSalesOrderDetails.party')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==3" prop="sapOrderNo" :label="$t('InternalOrder.form.wmsOrderNo')" show-overflow-tooltip align="center" />
                <el-table-column v-if="form.relevance==3" prop="totalOrderStatus" :label="$t('orderNewPatch.Status')" show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                      <el-tag>{{ $t(ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(scope.row.totalOrderStatus))}}</el-tag>
                  </template>
                </el-table-column>
                <!-- 行内删除 -->
                <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
                  <template slot-scope="scope">
                    <el-button :disabled="!['add','edit'].includes($route.query.type)" type="text" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div v-if="form.relevance" class="bj-form-tips" style="margin-top: 15px;font-size: 14px;font-weight: 700;color: #606266;">
                {{ $t('UploadTotalText') }}：{{ form.workOrderSpoVOList.length || 0 }}
              </div> -->
            </el-col>
            <!-- 处理人 -->
            <!-- <el-col :span="colSpan/2" v-if="$route.query.type != 'add'">
              <el-form-item :label="$t('workOrderList.Processing')">
                <BjSelectLov disabled v-model="userPageName" :option-list="userRoleList"/>
              </el-form-item>
            </el-col> -->
            <!-- 紧急程度 -->
            <!-- <el-col :span="colSpan/2" v-if="$route.query.type != 'add'">
              <el-form-item :label="$t('workOrderList.Urgent')">
                <BjSelectLov disabled v-model="exigency" :option-list="CSG_WORK_ORDER_EXIGENCY"/>
              </el-form-item>
            </el-col> -->
            <!-- 单个文件 -->
            <el-col :span="colSpan*2">
              <div class="flex flex-spacebetween" style="margin-top:10px;">
                <div class="profit-fileLeft">
                  <el-form-item :label="$t('workOrderList.enclosure')" prop="accessories"> 
                    <UploadFile ref="UploadAccessoriesFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.docx', '.xlsx', 'txt']" auto-upload limit-hide @handleFileListChange="fileChange">
                      <template slot="default">
                        <el-button :disabled="['view','audit','completed','hoursDone'].includes($route.query.type)" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                      </template>
                    </UploadFile>
                  </el-form-item>
                </div>
                <div class="profit-fileRight">
                  <template v-if="accessoriesArr.length>0">
                    <div class="file" style="line-height:1.5;font-weight: 500;font-size: 14px;">
                      <!-- <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.shippingLabelUpdate') }}:</div> -->
                      <div class="fileUpload">
                        <div v-for="(item, index) in accessoriesArr" :key="index" class="flex-align flex-spacebetween" style="color: #3173d0; cursor: pointer;">
                          <div class="flex">
                            <span>File{{ index + 1 }}:</span>
                            <div style="width: 200px;" class="ellipsis">
                              <span class="mr20">{{ item.name }}</span>
                            </div>
                          </div>
                          
                          <div class="flex-align flex-spacebetween">
                            <el-button size="mini" class="edit-btn" style="font-size: 12px;margin-right:10px" @click="downloadImageUrl(item.url, item.name)">{{ $t('downloadText') }}<i class="el-icon-download el-icon--right"></i></el-button>
                            <el-button size="mini" :disabled="$route.query.type=='view'" class="delete-btn" style="font-size: 12px;margin-right:10px" @click="delImg('accessoriesArr', index)">{{ $t('delText') }}<i class="el-icon-delete red el-icon--right"></i></el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template> 
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="profit-topRight">
          <!-- 工单描述 -->
          <div>
            <el-form-item :label="$t('workOrderList.Work')" prop="remark">
              <BjInput :disabled="['view','audit','completed','hoursDone'].includes($route.query.type)" v-model="form.remark" :maxlength="MAX_LENGTH.MAX" type="textarea" :rows="20" show-word-limit autosize />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="flex flex-spacebetween" v-if="!$store.getters.cusId">
        <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
        <div class="profit-left" v-if="[3,4,5,6,7,9].includes(this.form.status)||($route.query.type=='audit'&&this.form.status == 2)">
          <!-- 部门审批 345679显示且不可编辑 2audit显示可编辑 2view不显示 1不显示-->
          <BjDivider>{{$t('workOrderList.auditTitle')}}</BjDivider>
          <el-row :gutter="20">
            <!-- 审核模块 ==>>>> 审核结果 -->
            <el-col :span="5">
              <el-form-item :label="$t('workOrderList.findings')" prop="chooseAudit">
                <BjSelectLov :disabled="this.form.status != 2" v-model="chooseAudit" :option-list="CSG_WORK_ORDER_REVIEW" />
              </el-form-item>
            </el-col>
            <!-- 审核通过 ==>>>> 紧急程度 -->
            <el-col :span="5" v-if="chooseAudit=='0'">
              <el-form-item :label="$t('workOrderList.Urgent')" prop="exigency">
                <BjSelectLov :disabled="this.form.status != 2" v-model="form.exigency" :option-list="CSG_WORK_ORDER_EXIGENCY" />
              </el-form-item>
            </el-col>
            <!-- 审核通过 ==>>>> 处理人 -->
            <el-col :span="5" v-if="chooseAudit=='0'">
              <el-form-item :label="$t('workOrderList.Processing')" prop="userName">
                <BjSelectLov :disabled="this.form.status != 2" v-model="form.userName" :option-list="userRoleList" @change="chooseAuditUser"/>
              </el-form-item>
            </el-col>
            <!-- 审核通过 ==>>>> 预计完成时间 -->
            <el-col :span="9" v-if="chooseAudit=='0'">
              <el-form-item :label="$t('workOrderList.CompletionTime')" prop="auditTime">
                <BjDateTimerangePicker :disabled="this.form.status != 2" v-model="queryParams_endTime" :picker-options="pickerOptions" :placeholder="$t('workOrderList.Completion')" />
              </el-form-item>
            </el-col>
            <!-- 审核不通过 ==>>>> 不通过原因 -->
            <el-col :span="19" v-if="chooseAudit=='1'">
              <el-form-item :label="$t('workOrderList.Reason')" prop="reason">
                <el-input :disabled="this.form.status != 2" v-model="form.reason" :maxlength="MAX_LENGTH.MAX" type="textarea" show-word-limit autosize />
              </el-form-item>
            </el-col>
            <!-- 指定部门 ==>>>> 指定部门下拉列表 -->
            <el-col :span="9" v-if="chooseAudit=='2'">
              <el-form-item :label="$t('workOrderList.DepartmentText')" prop="consultName">
                <BjSelectLov :disabled="this.form.status != 2" v-model="form.consultName" :option-list="consultNameList" @change="getSection"/>
              </el-form-item>
            </el-col>
            <!-- 服务 ==>>>> 服务下拉列表（审核） -->
            <el-col :span="10" v-if="chooseAudit=='2'">
              <el-form-item :label="$t('workOrderList.service')" prop="workOrderTypeBottomId">
                <BjSelectLov :disabled="this.form.status != 2 || !form.consultName" v-model="form.workOrderTypeBottomId" :option-list="workOrderTypeIdBottomList" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 处理结果 处理中查看进来不显示 处理中完成处理进来可编辑（不显示工时）， -->
          <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
          <BjDivider v-if="(['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status)) || ($route.query.type=='completed'&&this.form.status==4)">{{$t('workOrderList.results')}}</BjDivider>
          <el-row :gutter="20"  v-if="(['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status)) || ($route.query.type=='completed'&&this.form.status==4)">
            <!-- 处理模块 ==>>>> 处理结果 -->
            <el-col :span="colSpan">
              <el-form-item :label="$t('workOrderList.results')" prop="handleResult">
                <BjSelectLov :disabled="$route.query.type== 'view'" v-model="form.handleResult" :option-list="CSG_WORK_ORDER_HANDLERESULT" />
              </el-form-item>
            </el-col>
            <!-- 处理模块 ==>>>> 总工时 -->
            <el-col :span="colSpan" v-if="['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status) || ($route.query.type=='completed'&&this.form.status==4)">
              <el-form-item :label="$t('workOrderList.Total')" prop="workingTime">
                <BjInput :disabled="$route.query.type== 'view'" v-model="form.workingTime" :maxlength="MAX_LENGTH.DEFAULT" show-word-limit />
              </el-form-item>
            </el-col>
            <!-- 处理模块 ==>>>> 工单回复 -->
            <el-col :span="colSpan*2">
              <el-form-item :label="$t('workOrderList.Ticket')" prop="handleResultOther">
                <BjInput :disabled="$route.query.type== 'view'" v-model="form.handleResultOther" :maxlength="MAX_LENGTH.MAX" type="textarea" :rows="5" show-word-limit autosize />
              </el-form-item>
            </el-col>
            <!-- 处理模块 ==>>>> 多文件 -->
            <el-col :span="colSpan*2">
              <div class="flex flex-spacebetween">
                <div class="profit-fileLeft">
                  <el-form-item :label="$t('workOrderList.enclosure')" prop="accessoriesList.adder"> 
                    <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.docx', '.xlsx', 'txt']" auto-upload limit-hide @handleFileListChange="fileListChange">
                      <template slot="default">
                        <el-button :disabled="$route.query.type== 'view'" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                      </template>
                    </UploadFile>
                  </el-form-item>
                </div>
                <div class="profit-fileRight">
                  <template v-if="fileList.length>0">
                    <div class="file" style="line-height:1.5;font-weight: 500;font-size: 14px;">
                      <!-- <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.shippingLabelUpdate') }}:</div> -->
                      <div class="fileUpload">
                        <div v-for="(item, index) in fileList" :key="index" class="flex-align flex-spacebetween" style="color: #3173d0; cursor: pointer;">
                          <div class="flex">
                            <span>File{{ index + 1 }}:</span>
                            <div style="width: 200px;" class="ellipsis">
                              <span class="mr20">{{ item.name }}</span>
                            </div>
                          </div>
                          
                          <div class="flex-align flex-spacebetween">
                            <el-button size="mini" class="edit-btn" style="font-size: 12px;margin-right:10px" @click="downloadImageUrl(item.url, item.name)">{{ $t('downloadText') }}<i class="el-icon-download el-icon--right"></i></el-button>
                            <el-button size="mini" :disabled="$route.query.type=='view'" class="delete-btn" style="font-size: 12px;margin-right:10px" @click="delImg('fileList', index)">{{ $t('delText') }}<i class="el-icon-delete red el-icon--right"></i></el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template> 
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="profit-right" v-if="['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status)">
          <!-- 确认收费 ===>>> 收费列表    59view显示不可编辑 59hoursDone显示可编辑-->
          <BjDivider>{{$t('workOrderList.customerTitle')}}</BjDivider>
          <div style="margin-top: -10px;">
            <div>
              <div style="float: left;line-height: 2;margin-top: 10px;font-size: 14px;font-weight: 700;color: #606266;" class="bj-form-title">{{ $t('workOrderList.Fee') }}:</div>
              <div style="float: right;margin-bottom: 10px;">
                <!-- 删除收费项 -->
                <el-button :disabled="SELECTED_CHARGE_ID.length == 0 || $route.query.type=='view'" type="danger" @click="onBatchDelCharge">{{ $t('goodsSku.package.delete') }}</el-button>
                <!-- 新增收费项 -->
                <el-button :disabled="$route.query.type=='view'" type="primary" @click="openCharge">{{ $t('addText') }}</el-button>
              </div>
            </div>
            <el-table :data="form.workOrderChargesVOList" stripe border :header-cell-style="$rowStyle.DEFAULT" @selection-change="chargeSelectionChange">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" />
              <el-table-column prop="tag" :label="$t('billingPage.tag')" show-overflow-tooltip align="center" >
                <template slot-scope="scope">
                  <span>{{ scope.row.tag == 'Ticket1'? $t('billingPage.timePay') : scope.row.tag == 'Ticket2'? $t('billingPage.quantityPay') : scope.row.tag}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pay" :label="$t('billingPage.Category')" show-overflow-tooltip align="center" />
              <el-table-column prop="number" :label="$t('billingPage.quantity')" align="center">
                <template slot-scope="scope">
                  <BjInputNumber :disabled="$route.query.type=='view'||scope.row.tag!='Ticket2'" v-model="scope.row.number" />
                </template>
              </el-table-column>
              <el-table-column prop="duration" :label="$t('workOrderList.Total')" show-overflow-tooltip align="center" >
                <template slot-scope="scope">
                  <BjInputNumber :disabled="$route.query.type=='view'||scope.row.tag!='Ticket1'" v-model="scope.row.duration" />
                </template>
              </el-table-column>
              <!-- 行内删除 -->
              <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
                <template slot-scope="scope">
                  <el-button :disabled="$route.query.type=='view'" type="text" @click="onDelCharge(scope.row)">{{ $t('delText') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="bj-form-tips" style="margin-top: 15px;font-size: 14px;font-weight: 700;color: #606266;">
              {{ $t('UploadTotalText') }}：{{ form.workOrderChargesVOList.length || 0 }}
            </div> -->
          </div>
          <div v-if="['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status)" style="padding-top:15px">
            <el-form-item :label="$t('workOrderList.Comments')+':'" prop="remarks">
              <BjInput :disabled="$route.query.type=='view'" v-model="form.remarks" :maxlength="MAX_LENGTH.MAX" type="textarea" :rows="5" show-word-limit autosize />
            </el-form-item>
          </div>
        </div>
        <!-- Internal Notes -->
        <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
        <div class="profit-right" v-if="[2,3,4,5,6,7,9].includes(this.form.status)">
          <BjDivider>{{$t('billingPage.InternalNotes')}}
            <template slot="right" v-if="$route.query.type=='view'">
              <el-button type="primary" @click="openNotesDialog">{{$t('billingPage.addInternalNotes')}}</el-button>
            </template>
          </BjDivider>
          <div style="width:100%;max-height: 500px;">
            <el-row :gutter="20">
              <el-col :span="colSpan*2" v-for="(item,index) in form.workOrderRemarkVoList" :key="index" >
                <el-form-item :label="`${item.user}  ${timeOperateTwoHour(item.createTime)}`" prop="message">
                  <BjWangEditor v-model="item.message" disabled :show-toolbar="false" :min-height="90" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- Messages -->
        <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
        <div class="profit-right" v-if="[2,3,4,5,6,7,9].includes(this.form.status)">
          <BjDivider>{{$t('billingPage.messages')}}
            <template slot="right">
              <el-button type="primary" @click="openMessagesDialog">{{$t('billingPage.addmessages')}}</el-button>
            </template>
          </BjDivider>
          <div style="width:100%;max-height: 500px;">
            <el-row :gutter="20">
              <el-col :span="colSpan*2" v-for="(item,index) in form.workOrderMessageVoList" :key="index" >
                <el-form-item :label="`${item.user}  ${timeOperateTwoHour(item.createTime)}`" prop="message">
                  <BjWangEditor v-model="item.message" disabled :show-toolbar="false" :min-height="90" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="flex flex-spacebetween" v-if="$store.getters.cusId">
        <!-- 处理结果 处理中查看进来不显示 处理中完成处理进来可编辑（不显示工时）， -->
        <!--  status： 1,草稿,2,待审批,3,待处理,4,处理中,5,已处理,6,审批不通过,7,已作废,8,逻辑删除,9,待确认 -->
        <div class="profit-left" v-if="(['view','hoursDone'].includes($route.query.type)&&[5,9].includes(this.form.status)) || ($route.query.type=='completed'&&this.form.status==4)">
          <BjDivider>{{$t('workOrderList.results')}}</BjDivider>
          <el-row :gutter="20">
            <!-- 处理模块 ==>>>> 处理结果 -->
            <el-col :span="colSpan*2/3">
              <el-form-item :label="$t('workOrderList.results')" prop="handleResult">
                <BjSelectLov :disabled="$route.query.type== 'view'" v-model="form.handleResult" :option-list="CSG_WORK_ORDER_HANDLERESULT" />
              </el-form-item>
            </el-col>
            <!-- 处理模块 ==>>>> 工单回复 -->
            <el-col :span="colSpan*2/3*2">
              <el-form-item :label="$t('workOrderList.Ticket')" prop="handleResultOther">
                <BjInput :disabled="$route.query.type== 'view'" v-model="form.handleResultOther" :maxlength="MAX_LENGTH.MAX" type="textarea" :rows="5" show-word-limit autosize />
              </el-form-item>
            </el-col>
            <!-- 处理模块 ==>>>> 多文件 -->
            <el-col :span="colSpan*2" style="margin-top: 20px;">
              <div class="flex flex-spacebetween">
                <div class="profit-fileLeft">
                  <el-form-item :label="$t('workOrderList.enclosure')" prop="accessoriesList.adder"> 
                    <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.docx', '.xlsx', 'txt']" auto-upload limit-hide @handleFileListChange="fileListChange">
                      <template slot="default">
                        <el-button :disabled="$route.query.type== 'view'" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                      </template>
                    </UploadFile>
                  </el-form-item>
                </div>
                <div class="profit-fileRight">
                  <template v-if="fileList.length>0">
                    <div class="file" style="line-height:1.5;font-weight: 500;font-size: 14px;">
                      <!-- <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.shippingLabelUpdate') }}:</div> -->
                      <div class="fileUpload">
                        <div v-for="(item, index) in fileList" :key="index" class="flex-align flex-spacebetween" style="color: #3173d0; cursor: pointer;">
                          <div class="flex">
                            <span>File{{ index + 1 }}:</span>
                            <div style="width: 200px;" class="ellipsis">
                              <span class="mr20">{{ item.name }}</span>
                            </div>
                          </div>
                        
                        <div class="flex-align flex-spacebetween">
                          <el-button size="mini" class="edit-btn" style="font-size: 12px;margin-right:10px" @click="downloadImageUrl(item.url, item.name)">{{ $t('downloadText') }}<i class="el-icon-download el-icon--right"></i></el-button>
                          <el-button size="mini" :disabled="$route.query.type=='view'" class="delete-btn" style="font-size: 12px;margin-right:10px" @click="delImg('fileList', index)">{{ $t('delText') }}<i class="el-icon-delete red el-icon--right"></i></el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template> 
              </div>
            </div>
            </el-col>
          </el-row>
        </div>
        <!-- Messages -->
        <div class="profit-right" v-if="[2,3,4,5,6,7,9].includes(this.form.status)">
          <BjDivider>{{$t('billingPage.messages')}}
            <template slot="right">
              <el-button type="primary" @click="openMessagesDialog">{{$t('billingPage.addmessages')}}</el-button>
            </template>
          </BjDivider>
          <div style="width:100%;max-height: 500px;">
            <el-row :gutter="20">
              <el-col :span="colSpan*2" v-for="(item,index) in form.workOrderMessageVoList" :key="index" >
                <el-form-item :label="`${item.user}  ${timeOperateTwoHour(item.createTime)}`" prop="message">
                  <BjWangEditor v-model="item.message" disabled :show-toolbar="false" :min-height="90" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 左 备注弹框 -->
    <BjDialog :title="$t('billingPage.addInternalNotes')" :visible="notesVisible" width="640px" destroy-on-close @close="clearVisibleLeft()">
      <el-form ref="commentForm" :model="commentForm" :rules="commentFormRules" label-width="100px" label-position="top">
          <el-form-item :label="$t('billingPage.Comments')" prop="comment">
            <BjWangEditor v-model="commentForm.comment" :placeholder="$t('billingPage.Comments')" :min-height="180" @blur="validateNotesComment" />
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearVisibleLeft()">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="addNotes">{{ $t('okText') }}</el-button>
      </span>
    </BjDialog>
    <!-- 右 备注弹框 -->
    <BjDialog :title="$t('billingPage.addmessages')" :visible="messagesVisible" width="640px" destroy-on-close @close="clearVisibleRight()">
      <el-form ref="messagesForm" :model="messagesForm" :rules="messagesFormRules" label-width="100px" label-position="top">
          <el-form-item :label="$t('billingPage.Comments')" prop="comment">
            <BjWangEditor v-model="messagesForm.comment" :placeholder="$t('billingPage.Comments')" :min-height="180" @blur="validateMessagesComment" />
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearVisibleRight()">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="addMessages">{{ $t('okText') }}</el-button>
      </span>
    </BjDialog>
    <!-- 选择普通商品 -->
    <BjDialogList ref="dialogListOrdinarySku" width="80%"
      :config="$BjDialogListConfig.skuDefault($t('SalesOrderEntry.goods'),{defaultQuery: { cusId: form.cusId, setFlag: 0, status: [3, 4, 5] }})" 
      multiple @confirm="onAddGoodsDialogConfirm"
    />
    
    <diaLogForm ref="dialogListPo" width="80%"
      :search-btn-span="8"
      :config="$BjDialogListConfig.POSelect('SelectPOText',{defaultQuery: { cusId: form.cusId, status: ['New','Uploaded','Arrived','Receiving','Received','UploadFail','Done'] }})" 
      multiple @confirm="onAddPODialogConfirm"
    />
    
    <diaLogForm ref="dialogListOrder" width="80%"
      :search-btn-span="12"
      :config="$BjDialogListConfig.OrderSelect('SelectOrderText',{defaultQuery: { cusId: form.cusId }})" 
      multiple @confirm="onAddOrderDialogConfirm"
    />

    <!-- 收费列表弹出框 --> 
    <BjDialogList ref="dialogListChangeItem" width="80%"
      :config="$BjDialogListConfig.chargeItemDefault('route.BusinessBillingCategories', {defaultQuery: {tags:'Ticket1,Ticket2', tenantId: $store.getters.tenantId}})"
      :resetBtnHide="true" :searchBtnHide="true"
      multiple @confirm="onAddChargeItemConfirm"
    />
  </div>
</template>
<script>
import { workorderApi,userApi  } from '@/api';
import viewMiXin from '@/utils/view-mixin.js';
import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
import diaLogForm from '../chooseDiaLog/diaLogForm';
import orderLog from '@/utils/log.js';
import { CSG_WORK_ORDER_EXIGENCY, CSG_WORK_ORDER_REVIEW, ORDER_INTERNAL_ALL_STATUS_LIST,CSG_WORK_ORDER_HANDLERESULT } from '@/utils/constants';
import moment from 'moment';

export default {
  name: 'BusinessWorkorderListForm',
  components: { UploadFile, diaLogForm },
  mixins: [viewMiXin],
  data() {
    return {
      colSpan: 12,
      ORDER_INTERNAL_ALL_STATUS_LIST,
      CSG_WORK_ORDER_EXIGENCY,
      CSG_WORK_ORDER_REVIEW,
      CSG_WORK_ORDER_HANDLERESULT,
      form: {
        cusId: this.$store.getters.cusId || null,
        consultType:null,
        workOrderTypeId:null,
        consultName:null,
        workOrderTypeBottomId:null,
        title:null,
        workNo:null,
        customer: this.$store.getters.userInfo.csgCustomer || null,
        companyName: this.$store.getters.userInfo.companyName || null,
        operationDepartment:null,
        remark:null,
        accessories:[],
        relevance: 0,
        workOrderSpoVOList: [],
        workingTime:null,
        accessoriesList:[],
        handleResult:null,
        handleResultOther:null,
        workOrderNoPre: null,
        workOrderChargesVOList: [],
      },
      // 部门下拉列表
      consultNameTopList:[],
      // 指定部门下拉列表
      consultNameList:[],
      // 服务下拉列表
      workOrderTypeIdList:[],
      // 服务下拉列表（审核）
      workOrderTypeIdBottomList:[],
      // 关联工单种类
      skuOrderPoList:[{label:'No Associated Object',value:0},{label:'SKU',value:1},{label:'PO',value:2},{label:'ORDER',value:3},],
      // 关联工单  ==》  列表选中数据返回
      multipleSelection: [],
      // 收费列表数据
      chargeSelection: [],
      // 审核是否通过 ==》 审核结果 下拉列表  0.通过  1.不通过
      chooseAudit: 0,
      // 审核是否通过 ==》 处理人 下拉列表
      userRoleList:[],
      // 审核是否通过 ==》 通过 传参参数userName
      userName:null,
      // 审核是否通过 ==》 通过 传参参数userId
      userId:null,
      // 审核是否通过 ==》 通过 时间 变量
      queryParams_endTime: [],
      // 审核是否通过 ==》 通过 开始时间参数
      scheduledStartTime: null,
      // 审核是否通过 ==》 通过 结束时间参数
      scheduledEndTime: null,
      // 文件上传  ==》 多个文件
      fileList:[],
      accessoriesArr: [],
      // 存储接口参数userPageName用于页面展示
      userPageName:null,
      // 存储接口参数exigency用于页面展示
      exigency:null,
      pickerOptions: {},
      // 左备注弹出框信息
      notesVisible:false,
      // 右备注弹出框信息
      messagesVisible:false,
      commentForm: {
        comment: null,
      },
      commentFormRules: {
        comment: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      messagesForm: {
        comment: null,
      },
      messagesFormRules: {
        comment: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  computed:{
    SELECTED_BJ_EBC_ID() {
      return this.multipleSelection.map(e => e.id) || [];
    },
    SELECTED_CHARGE_ID() {
      return this.chargeSelection.map(e => e.id) || [];
    },
    rules() {
      const validateAuditTime = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.scheduledStartTime || !this.scheduledEndTime) {
            callback(new Error(this.$t('chooseText')));
          }
          callback();
        });
      };

      return {
        cusId: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        title: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        consultType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        workOrderTypeId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        remark: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        userName: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        auditTime: [{ required: true, validator: validateAuditTime, trigger: 'change' }],
        exigency: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        reason: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        handleResult: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        consultName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        workOrderTypeBottomId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      };
    },
    customerList() {
      return this.$store.getters.customerList;
    },
  },
  watch: {
      queryParams_endTime(v) {
        this.scheduledStartTime = (v || [])[0];
        this.scheduledEndTime = (v || [])[1];
      },
    },
  created(){  
    if(this.$route.query.type != 'view'){
      this.init()
    }
  },
  activated() {
    if(this.$route.query.type == 'view'){
      this.init()
    }
  },
  methods: {
    timeOperateTwoHour(date) {
      if (date) {
        // 获取澳洲当前时间与本地时间的时差
        const timeHour = sessionStorage.getItem('timeHour') || '2';
        var time = Date.parse(new Date(date));
        var newTime = moment(time + timeHour * 3600000).format('DD/MM/YYYY HH:mm');
        return newTime;
      }
    },
    // 左备注弹窗 新增 
    addNotes(){
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          const POST_DATA = {
            message : this.commentForm.comment,
            ticketId : this.$route.query.id
          }
          workorderApi.workOrderSendRemark(POST_DATA).then(res=>{
            if(!res.failed){
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.clearVisibleLeft()
              this.init()
            }
          })
        }
      })
    },
    // 右备注弹窗 新增 
    addMessages(){
      this.$refs.messagesForm.validate(valid => {
        if (valid) {
          const POST_DATA = {
            message : this.messagesForm.comment,
            ticketId : this.$route.query.id
          }
          workorderApi.workOrderSendMessage(POST_DATA).then(res=>{
            if(!res.failed){
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.clearVisibleRight()
              this.init()
            }
          })
        }
      })
    },
    // 清空数据并关闭弹出框
    openNotesDialog(){
      this.commentForm.comment = '';
      this.notesVisible = true;
      this.$nextTick(() => {
        this.$refs.commentForm && this.$refs.commentForm.clearValidate();
      });
    },
    openMessagesDialog(){
      this.messagesForm.comment = '';
      this.messagesVisible = true;
      this.$nextTick(() => {
        this.$refs.messagesForm && this.$refs.messagesForm.clearValidate();
      });
    },
    validateNotesComment(){
      setTimeout(() => {
        if (!this.notesVisible) return;
        this.$refs.commentForm && this.$refs.commentForm.validateField('comment');
      }, 0);
    },
    validateMessagesComment(){
      setTimeout(() => {
        if (!this.messagesVisible) return;
        this.$refs.messagesForm && this.$refs.messagesForm.validateField('comment');
      }, 0);
    },
    clearVisibleLeft(){
      this.notesVisible = false;
      this.commentForm.comment = '';
      this.clearDialogValidate('commentForm');
    },
    // 清空数据并关闭弹出框
    clearVisibleRight(){
      this.messagesVisible = false;
      this.messagesForm.comment = '';
      this.clearDialogValidate('messagesForm');
    },
    clearDialogValidate(formRef){
      this.$nextTick(() => {
        this.$refs[formRef] && this.$refs[formRef].clearValidate();
      });
      setTimeout(() => {
        this.$refs[formRef] && this.$refs[formRef].clearValidate();
      }, 0);
    },
    init(){
      if(this.$route.query.type!='add'){
        this.getFormData();
      }
      if(this.$store.getters.cusId){
        this.form.workOrderNoPre = 'TW-'+this.$store.getters.userInfo.clientCode
      }
      // 获取部门下拉数据
      this.getWorkOrderConsultTopType()
      // 获取处理部门下拉数据
      // this.getWorkOrderConsultType()
    },
    showLog() {
        orderLog(
          this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
            actionApi: workorderApi.workOrderLogs,
            defaultQuery: {
              wOrderNo: this.form.workNo
            },
            columns: [
              {
                prop: 'createByName',
                label: 'BjDialogListConfig.Operator',
              },
              {
                prop: 'creationDate',
                label: 'BjDialogListConfig.Operationtime',
              },
              {
                prop: 'content',
                label: 'BjDialogListConfig.Remarks',
              },
            ],
            search: [],
          }),
        );
    },
    delImg(name, index){
      this[name].splice(index, 1)
    },
    // 单个上传的文件
    fileChange(file) {
      this.accessoriesArr = file.filter(item => item.url);
    },
    // 上传的文件列表
    fileListChange(file) {
      this.fileList = file.filter(item => item.url);
    },
    // 获取审核页需要的处理人
    getOperaterList(operationDepartment){
      userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:operationDepartment, size:999}).then(res=>{
        this.userRoleList = res.content.map(item => {
          return { label: item.realName, value: item.id };
        });
      })
    },
    // 处理人 审核是否通过 接口需要的字段
    chooseAuditUser(v,k){
      this.userName = k.label
      this.userId = v
    },
    // admin选择客户后 进行拼接传参
    changeCustomer(e,v){
      this.form.workOrderNoPre = 'TW-'+ v.clientCode
      this.form.customer = v.csgCustomer
      this.form.companyName = v.companyName
    },
    // 获取部门下拉数据
    getWorkOrderConsultTopType(){
      workorderApi.getConsultationTypeList().then(res=>{
        // 部门下拉列表
        this.consultNameTopList = res.content.map(item => {
          return { label: item.consultName, value: item.consultName, name: item.section };
        });
        // 指定部门下拉列表
        this.consultNameList = res.content.map(item => {
          return { label: item.consultName, value: item.consultName, name: item.section };
        });
      })
    },
    // 指定部门下拉列表（暂废弃）
    // getWorkOrderConsultType(){
    //   userApi.getDepartmentList().then(res=>{
    //     this.consultNameList = res.map(item => {
    //       return { label: item.name, value: item.name };
    //     });
    //   })
    // },
    // 指定部门 后 审核使用字段赋值
    getSection(n,m){
      this.form.section = m.name
      this.form.workOrderTypeBottomId = null
      this._ordertypeList2(n)
    },
    // 获取服务下拉数据
    getNextList(n,m){
      this.form.workOrderTypeId = null
      if(m){
        this.form.operationDepartment = m.name
      }
      this._ordertypeList(n)
    },
    _ordertypeList(n){
      workorderApi.ordertypeList({
        consultName: n || this.form.consultType,
        prohibits: 1,
        currentPage: 0,
        page: 0,
        pagesize: 999,
        size: 999,
      }).then(res=>{
        this.workOrderTypeIdList = res.content.map(e=>{
            return {label : e.name,value : e.id}
        })
      })
    },
    _ordertypeList2(n){
      workorderApi.ordertypeList({
        consultName: n || this.form.consultType,
        prohibits: 1,
        currentPage: 0,
        page: 0,
        pagesize: 999,
        size: 999,
      }).then(res=>{
        this.workOrderTypeIdBottomList = res.content.map(e=>{
            return {label : e.name,value : e.id}
        })
      })
    },
    // 根据id获取详情页数据
    getFormData() {
      if(!this.$store.getters.cusId){
        workorderApi.getWorkOrderDetail({ id: this.$route.query.id }).then(async res => {
          await this._ordertypeList(res.consultType)
          this.pickerOptions = {
              disabledDate(time) {
                  return time.getTime() < new Date(res.creationDate).getTime() - 3600 * 1000 * 24;
              },
          };

          this.form = res;
          // 多文件回显处理
          if(this.form.accessoriesList){
            this.fileList = this.form.accessoriesList.map(item=>{
              return {name: item.name, url: item.adder}
            });
          }
          if(this.form.accessories){
            this.accessoriesArr = this.form.accessories.map(item=>{
              return {name: item.name, url: item.adder}
            });
          }
          this.$refs.UploadAccessoriesFileRef.fileList = this.accessoriesArr;
          this.userPageName = this.form.userName;
          this.exigency = this.form.exigency;
          if(this.form.scheduledStartTime || this.form.scheduledEndTime){
            this.queryParams_endTime = [new Date(this.form.scheduledStartTime),new Date(this.form.scheduledEndTime)]
          }else{
            this.queryParams_endTime = []
          }
          this.chooseAudit = this.form.reason? 1:0 
          // 审核使用，获取处理人列表
          this.getOperaterList(this.form.operationDepartment)
          // 多文件上传处理   
          this.$nextTick(()=>{
            if((['view','hoursDone'].includes(this.$route.query.type)&&[5,9].includes(this.form.status)) || (this.$route.query.type=='completed'&&this.form.status==4)){
              this.$refs.UploadFileRef.fileList = this.fileList;
            }
          })
        });
      }else{
        workorderApi.getWorkOrderDetailUser({ id: this.$route.query.id ,clientCode:this.$store.getters.userInfo.clientCode}).then(async res => {
          await this._ordertypeList(res.consultType)
          this.form = res;
          // 多文件回显处理
          if(this.form.accessoriesList){
            this.fileList = this.form.accessoriesList.map(item=>{
              return {name: item.name, url: item.adder}
            });
          }
          if(this.form.accessories){
            this.accessoriesArr = this.form.accessories.map(item=>{
              return {name: item.name, url: item.adder}
            });
          }
          this.$refs.UploadAccessoriesFileRef.fileList = this.accessoriesArr;
          this.userPageName = this.form.userName;
          this.exigency = this.form.exigency;
          if(this.form.scheduledStartTime || this.form.scheduledEndTime){
            this.queryParams_endTime = [new Date(this.form.scheduledStartTime),new Date(this.form.scheduledEndTime)]
          }else{
            this.queryParams_endTime = []
          }
          this.chooseAudit = this.form.reason? 1:0 
          // 审核使用，获取处理人列表
          this.getOperaterList(this.form.operationDepartment)
          // 多文件上传处理
          this.$nextTick(()=>{
            if((['view','hoursDone'].includes(this.$route.query.type)&&[5,9].includes(this.form.status)) || (this.$route.query.type=='completed'&&this.form.status==4)){
              this.$refs.UploadFileRef.fileList = this.fileList;
            }
          })
        });
      }
    },
    // 添加sku
    openSelectForm() {
      if(this.form.relevance==1){
        this.$refs['dialogListOrdinarySku'].show();
      }else if(this.form.relevance==2){
        this.$refs['dialogListPo'].showDialog();
      }else if(this.form.relevance==3){
        this.$refs['dialogListOrder'].showDialog();
      }
    },
    // 单独删除
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const index = this.form.workOrderSpoVOList.findIndex(e => e.id == row.id);
        if (index > -1) this.form.workOrderSpoVOList.splice(index, 1);
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    // 批量删除
    onBatchDelete() {
      this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.SELECTED_BJ_EBC_ID.forEach(id => {
          const index = this.form.workOrderSpoVOList.findIndex(e => e.id == id);
          if (index > -1) this.form.workOrderSpoVOList.splice(index, 1);
        });
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    // 添加收费列表
    openCharge() {
      this.$refs['dialogListChangeItem'].showDialog();
    },
    // 单独删除收费列表
    onDelCharge(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const index = this.form.workOrderChargesVOList.findIndex(e => e.id == row.id);
        if (index > -1) this.form.workOrderChargesVOList.splice(index, 1);
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    // 批量删除收费列表
    onBatchDelCharge() {
      this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.SELECTED_CHARGE_ID.forEach(id => {
          const index = this.form.workOrderChargesVOList.findIndex(e => e.id == id);
          if (index > -1) this.form.workOrderChargesVOList.splice(index, 1);
        });
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    // 列表选中数据返回
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 收费列表选中数据返回
    chargeSelectionChange(val) {
      this.chargeSelection = val;
    },
    // 添加收费列表后返回
    onAddChargeItemConfirm(data) {
      if (data && !data[0].id) return;
      data.forEach(async(item) => {
        if (!this.form.workOrderChargesVOList.find(ee => ee.id == item.id)) {
          this.form.workOrderChargesVOList.push({
            // id 批量删除用
            id: item.id,
            // 以下四个值 列表展示用
            pay: item.billCategoryName,
            number: null,
            duration: null,
            payCode: item.billCategoryCode,
            tag: item.tag.includes('Ticket1')?'Ticket1' : item.tag.includes('Ticket2')?'Ticket2' : null,
          });
        }
      });
    },
    // 添加SKU后返回
    onAddGoodsDialogConfirm(data) {
      if (data && !data[0].id) return;
      data.forEach(async(item) => {
        if (!this.form.workOrderSpoVOList.find(ee => ee.id == item.id)) {
          this.form.workOrderSpoVOList.push({
            // id 批量删除用
            id: item.id,
            // 以下四个值 列表展示用
            skuName: item.skuName,
            skuCode: item.skuCode,
            standardSkuCode: item.standardSkuCode,
            barCode: item.barCode,
            quantity: item.qty || 1,
          });
        }
      });
    },
    // 添加PO后返回
    onAddPODialogConfirm(data) {
      if (data && !data[0].id) return;
      data.forEach(async(item) => {
        if (!this.form.workOrderSpoVOList.find(ee => ee.id == item.id)) {
          this.form.workOrderSpoVOList.push({
            // id 批量删除用
            id: item.id,
            // 以下四个值 列表展示用
            code: item.code,
            shippingMethod: item.shippingMethod,
            containerId: item.containerId,
            status: item.status,
          });
        }
      });
    },
    // 添加Order后返回
    onAddOrderDialogConfirm(data) {
      if (data && !data[0].id) return;
      data.forEach(async(item) => {
        if (!this.form.workOrderSpoVOList.find(ee => ee.id == item.id)) {
          this.form.workOrderSpoVOList.push({
            // id 批量删除用
            id: item.id,
            // 以下四个值 列表展示用
            outerOrderNo: item.outerOrderNo,
            webReference: item.webReference,
            sapOrderNo: item.sapOrderNo,
            totalOrderStatus: item.totalOrderStatus,
          });
        }
      });
    },
    /* 保存 */
    handleConfirm() {
      // 相关类型数据非空验证
      if([1,2,3].includes(this.form.relevance)&&this.form.workOrderSpoVOList.length==0){
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning2'));
        return;
      }

      this.$refs.form.validate(valid => {
        if (valid) {
          let accessoriesArrCopy = []
          if(this.accessoriesArr.length > 0){
            accessoriesArrCopy = this.accessoriesArr.map(item => {
              return { name: item.name, url: item.url };
            });
          }
          this.form.accessories = JSON.stringify(accessoriesArrCopy)
          let POST_DATA = {}
          if(!this.$store.getters.cusId){
            POST_DATA = {
              ...this.form,
              workOrderSpoVOList: this.form.workOrderSpoVOList.map(e => {
                return {
                  // sku
                  skuName: e.skuName,
                  skuCode: e.skuCode,
                  standardSkuCode: e.standardSkuCode,
                  barCode: e.barCode,
                  quantity: e.quantity,
                  // po
                  code: e.code,
                  shippingMethod: e.shippingMethod,
                  containerId: e.containerId,
                  status: e.status,
                  // order
                  outerOrderNo: e.outerOrderNo,
                  webReference: e.webReference,
                  sapOrderNo: e.sapOrderNo,
                  totalOrderStatus: e.totalOrderStatus,
                };
              }),
              workOrderChargesVOList: this.form.workOrderChargesVOList?.map(e => {
                return {
                  // 收费列表
                  pay: e.pay,
                  number: e.number,
                  duration: e.duration,
                  payCode: e.payCode,
                  tag: e.tag,
                };
              })
            }
          }else{
            POST_DATA = {
              ...this.form,
              workOrderSpoVOList: this.form.workOrderSpoVOList.map(e => {
                return {
                  // sku
                  skuName: e.skuName,
                  skuCode: e.skuCode,
                  standardSkuCode: e.standardSkuCode,
                  barCode: e.barCode,
                  quantity: e.quantity,
                  // po
                  code: e.code,
                  shippingMethod: e.shippingMethod,
                  containerId: e.containerId,
                  status: e.status,
                  // order
                  outerOrderNo: e.outerOrderNo,
                  webReference: e.webReference,
                  sapOrderNo: e.sapOrderNo,
                  totalOrderStatus: e.totalOrderStatus,
                };
              }),
            }
          }
          
          if(this.$route.query.type=='edit'){
            workorderApi.modifyWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }else{
            workorderApi.postNewWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }
        }
      });
    },
    /* 保存并提交 */
    handleSubmit() {
      // 相关类型数据非空验证
      if([1,2,3].includes(this.form.relevance)&&this.form.workOrderSpoVOList.length==0){
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning2'));
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          let accessoriesArrCopy = []
          if(this.accessoriesArr.length > 0){
            accessoriesArrCopy = this.accessoriesArr.map(item => {
              return { name: item.name, url: item.url };
            });
          }
          this.form.accessories = JSON.stringify(accessoriesArrCopy)
          let POST_DATA = {}
          if(!this.$store.getters.cusId){
            POST_DATA = {
              ...this.form,
              workOrderSpoVOList: this.form.workOrderSpoVOList.map(e => {
                return {
                  // sku
                  skuName: e.skuName,
                  skuCode: e.skuCode,
                  standardSkuCode: e.standardSkuCode,
                  barCode: e.barCode,
                  quantity: e.quantity,
                  // po
                  code: e.code,
                  shippingMethod: e.shippingMethod,
                  containerId: e.containerId,
                  status: e.status,
                  // order
                  outerOrderNo: e.outerOrderNo,
                  webReference: e.webReference,
                  sapOrderNo: e.sapOrderNo,
                  totalOrderStatus: e.totalOrderStatus,
                };
              }),
              workOrderChargesVOList: this.form.workOrderChargesVOList?.map(e => {
                return {
                  // 收费列表
                  pay: e.pay,
                  number: e.number,
                  duration: e.duration,
                  payCode: e.payCode,
                  tag: e.tag,
                };
              })
            }
          }else{
            POST_DATA = {
              ...this.form,
              workOrderSpoVOList: this.form.workOrderSpoVOList.map(e => {
                return {
                  // sku
                  skuName: e.skuName,
                  skuCode: e.skuCode,
                  standardSkuCode: e.standardSkuCode,
                  barCode: e.barCode,
                  quantity: e.quantity,
                  // po
                  code: e.code,
                  shippingMethod: e.shippingMethod,
                  containerId: e.containerId,
                  status: e.status,
                  // order
                  outerOrderNo: e.outerOrderNo,
                  webReference: e.webReference,
                  sapOrderNo: e.sapOrderNo,
                  totalOrderStatus: e.totalOrderStatus,
                };
              }),
            }
          }

          workorderApi.submitWorkOrder(POST_DATA).then(res=>{
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.complete('BusinessOpenWorkorderList');
              }, 500);
            }
          })
        }
      });
    },
    // 审核是否通过
    handleSubmitChoose(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.chooseAudit=='0'){
            const POST_DATA = {
              id:this.$route.query.id,
              userName:this.userName,
              userId:this.userId,
              exigency: this.form.exigency,
              scheduledStartTime: this.scheduledStartTime,
              scheduledEndTime: this.scheduledEndTime,
            }
            workorderApi.examinePassWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }else if(this.chooseAudit=='1'){
            const POST_DATA = {
              id:this.$route.query.id,
              reason: this.form.reason,
            }
            workorderApi.failTheAuditWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }else if(this.chooseAudit=='2'){
            const POST_DATA = {
              id:this.$route.query.id,
              workNo: this.form.workNo,
              operationDepartment: this.form.section,
              consultType: this.form.consultName,
              workOrderTypeId: this.form.workOrderTypeBottomId,
            }
            workorderApi.modifyDepWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }
        }
      });
    },
    // 完成处理
    handleFinish(){
      this.$refs.form.validate(valid => {
        if (valid) {
            if(this.form.handleResult=='Other' && !this.form.handleResultOther){
              return this.$message.warning(this.$t('workOrderList.Ticket')+this.$t('emptyWarningText'));
            }
            
            let fileAddressCopy = [];
            if (this.fileList.length > 0) {
              fileAddressCopy = this.fileList.map(item => {
                return { name: item.name, url: item.url };
              });
            }
            if(fileAddressCopy.length == 0 && this.form.requiresAttach == 1) return this.$message.warning(this.$t('ExcelConfig.upload'));
            const POST_DATA = {
              id:this.$route.query.id,
              handleResult:this.form.handleResult,
              workingTime:this.form.workingTime,
              handleResultOther:this.form.handleResultOther,
              fileAddress:JSON.stringify(fileAddressCopy),
            }
            workorderApi.finishWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
        }
      })
    },
    // 工时确认
    ConfirmTime(){
      this.$refs.form.validate(valid => {
        if (valid) {
            if(this.form.handleResult=='Other' && !this.form.handleResultOther){
              return this.$message.warning(this.$t('workOrderList.Ticket')+this.$t('emptyWarningText'));
            }
            let fileAddressCopy = [];
            if (this.fileList.length > 0) {
              fileAddressCopy = this.fileList.map(item => {
                return { name: item.name, url: item.url };
              });
            }
            if(fileAddressCopy.length == 0 && this.form.requiresAttach == 1) return this.$message.warning(this.$t('ExcelConfig.upload'));
            const POST_DATA = {
              id:this.$route.query.id,
              handleResult:this.form.handleResult,
              handleResultOther:this.form.handleResultOther,
              workingTime:this.form.workingTime,
              fileAddress:JSON.stringify(fileAddressCopy),
              workOrderChargesVOList:this.form.workOrderChargesVOList,
              remarks:this.form.remarks,
            }
            
            let bstop = 0;
            let chargeName = null
            POST_DATA.workOrderChargesVOList = POST_DATA.workOrderChargesVOList.map(e => {
              if(e.tag=='Ticket1'&&!e.duration){
                bstop = 1
                chargeName = e.pay
              }else if(e.tag=='Ticket2'&&!e.number){
                bstop = 2
                chargeName = e.pay
              }
              return {
                // 收费列表
                pay: e.pay,
                number: e.number,
                duration: e.duration,
                payCode: e.payCode,
                tag: e.tag,
              };
            });
            if(bstop == 1){
              return this.$message.warning(`${this.$t('inputText')} ${chargeName} ${this.$t('workOrderList.Total')}`);
            }else if(bstop == 2){
              return this.$message.warning(`${this.$t('inputText')} ${chargeName} ${this.$t('billingPage.quantity')}`);
            }

            workorderApi.sureWorkOrder(POST_DATA).then(res=>{
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.complete('BusinessOpenWorkorderList');
                }, 500);
              }
            })
          }
        })
    },
    /* 返回 */
    handleClose() {
      this.cancel();
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  width: 100%;
}
.profit{
    &-title{
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
    }
    &-top{
        padding: 0 20px 50px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
        min-height: 480px;
    }
    &-bottom{
        padding: 0 20px 50px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
    }
    &-topLeft{
        background: #fff;
        width: 50%;
        padding: 0 20px;
    }
    &-topRight{
        background: #fff;
        width: 50%;
        padding: 0 20px;
    }
    &-fileLeft{
        background: #fff;
        width: 120px;
        padding: 0 20px;
    }
    &-fileRight{
        background: #fff;
        width: calc(100% - 120px);
        padding: 0 20px;
    }
    &-left{
        background: #fff;
        width: 49%;
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 10px;
        margin-bottom: 20px;
    }
    &-right{
        background: #fff;
        width: 49%;
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 10px;
        margin-bottom: 20px;
    }
    
}
</style>
